import { render, staticRenderFns } from "./AllYouNeed.vue?vue&type=template&id=f0b33804&scoped=true"
import script from "./AllYouNeed.vue?vue&type=script&lang=js"
export * from "./AllYouNeed.vue?vue&type=script&lang=js"
import style0 from "./AllYouNeed.vue?vue&type=style&index=0&id=f0b33804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b33804",
  null
  
)

export default component.exports